"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const clsx_1 = __importDefault(require("clsx"));
const react_1 = __importDefault(require("react"));
const Tooltip_1 = __importDefault(require("../Tooltip/Tooltip"));
const ButtonIconSolo = ({ children, withBackground, tooltip, ...rest }) => {
    return (react_1.default.createElement(Tooltip_1.default, { content: tooltip, delay: 0 },
        react_1.default.createElement("button", { type: "button", className: (0, clsx_1.default)('sds-btn-icon-solo', withBackground ? 'btn-default' : 'btn-default-transparent'), ...rest }, children)));
};
exports.default = ButtonIconSolo;
